import SuggestionsList from "./SuggestionsList";

export default SuggestionsList;
